import React, { useState, useEffect } from "react";

export default function HowToPlayModal({ onClose }) {
  const [isVisible, setIsVisible] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);
  const totalPages = 2;

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 10);
    return () => clearTimeout(timer);
  }, []);

  const handleClose = () => {
    setIsVisible(false);
    setTimeout(onClose, 500);
  };



  return (
    <div
      className={`fixed inset-0 flex items-center justify-center z-50 p-4 transition-colors duration-500 ${
        isVisible ? "bg-black/80" : "bg-black/0"
      }`}
      onClick={handleClose}
    >
      <div
        className={`bg-[#f3e9d2] text-[#5a4a3a] w-full max-w-2xl h-[85vh] sm:h-[90vh] p-6 sm:p-8 shadow-2xl flex flex-col rounded-lg border-4 border-gray-700 transition-all duration-500 ease-out ${
          isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"
        }`}
        onClick={(e) => e.stopPropagation()}
      >
        <h2 className="text-3xl sm:text-4xl font-bold mb-4 flex-shrink-0 font-serif text-center">
          วิธีการเล่น
        </h2>

        <div className="flex-grow overflow-y-auto pr-4 space-y-6">
          {currentPage === 0 && (
            <div className="animate-fade-in space-y-6">
              <div>
                <h3 className="text-2xl font-bold font-serif border-b-2 border-[#c8bda9] pb-1 mb-2">
                  เป้าหมายของเกม
                </h3>
                <ul className="list-disc list-inside space-y-1">
                  <li>
                    <strong className="text-blue-800">
                      ฝ่ายผู้บริสุทธิ์ (Innocent Team):
                    </strong>{" "}
                    ช่วยกันวิเคราะห์หาตัวฆาตกร และโหวตกำจัด{" "}
                    <strong className="text-red-800">ฆาตกร</strong>{" "}
                    ออกจากเกมให้หมด
                  </li>
                  <li>
                    <strong className="text-red-800">
                      ฝ่ายฆาตกร (Murderer Team):
                    </strong>{" "}
                    สังหารผู้เล่นฝ่ายผู้บริสุทธิ์ไปเรื่อยๆ
                    จนกระทั่งจำนวนของฝ่ายตนเอง{" "}
                    <strong className="text-black">เท่ากับหรือมากกว่า</strong>{" "}
                    จำนวนฝ่ายผู้บริสุทธิ์ที่เหลือรอด
                  </li>
                </ul>
              </div>
              <div>
                <h3 className="text-2xl font-bold font-serif border-b-2 border-[#c8bda9] pb-1 mb-2">
                  ลำดับการเล่น
                </h3>
                <ol className="list-decimal list-inside space-y-2">
                  <li>
                    <strong>เฟสกลางคืน:</strong>
                    <ul className="list-disc list-inside pl-4 mt-1 text-sm">
                      <li>ฆาตกรเลือกสังหารเหยื่อ 1 คน</li>
                      <li>
                        เหยื่อที่ถูกสังหารจะได้รับรู้ว่าใครฆ่าตน
                        และต้องเลือกเบาะแส "ของจริง" 1 ชิ้นจาก 9
                        ชิ้นเพื่อทิ้งไว้
                      </li>
                      <li>
                        ฆาตกรจะต้องเลือกเบาะแส "ของปลอม" 2
                        ชิ้นเพื่อนำไปปะปนกับของจริง
                      </li>
                    </ul>
                  </li>
                  <li>
                    <strong>เฟสกลางวัน:</strong>
                    <ul className="list-disc list-inside pl-4 mt-1 text-sm">
                      <li>
                        ทุกคนจะเห็นเบาะแสที่ถูกผสมแล้ว (ของจริง + ของปลอม)
                      </li>
                      <li>
                        ผู้เล่นทุกคนมีเวลา 60
                        วินาทีเพื่อปรึกษาหารือและวิเคราะห์ว่าใครคือฆาตกร
                      </li>
                    </ul>
                  </li>
                  <li>
                    <strong>เฟสโหวต:</strong>
                    <ul className="list-disc list-inside pl-4 mt-1 text-sm">
                      <li>ผู้เล่นทุกคนโหวตคนที่สงสัยที่สุด 1 คน</li>
                      <li>
                        ผู้เล่นที่ได้รับคะแนนโหวตสูงสุดจะถูกกำจัดออกจากเกม
                      </li>
                    </ul>
                  </li>
                  <li>
                    <strong>เริ่มรอบใหม่:</strong>{" "}
                    เกมจะดำเนินต่อไปจนกว่าฝ่ายใดฝ่ายหนึ่งจะทำตามเงื่อนไขชนะของตัวเองได้สำเร็จ
                  </li>
                </ol>
              </div>
            </div>
          )}

          {currentPage === 1 && (
            <div className="animate-fade-in">
              <h3 className="text-2xl font-bold font-serif border-b-2 border-[#c8bda9] pb-1 mb-2">
                บทบาทต่างๆ
              </h3>
              <div className="space-y-4">
                <div className="flex items-start gap-4">
                  <img
                    src="/images/role_cards/card_murderer_v1.png"
                    alt="การ์ดฆาตกร"
                    className="w-20 h-auto rounded-md shadow-md flex-shrink-0"
                  />
                  <div>
                    <strong className="text-red-800 text-lg">
                      ฆาตกร (Murderer)
                    </strong>
                    <p className="text-sm">
                      เลือกสังหารผู้เล่น 1 คนในตอนกลางคืน และเลือกเบาะแสปลอม 2
                      ชิ้นเพื่อปั่นหัวทุกคน
                    </p>
                  </div>
                </div>
                <div className="flex items-start gap-4">
                  <img
                    src="/images/role_cards/card_assistant_v1.png"
                    alt="การ์ดผู้ช่วย"
                    className="w-20 h-auto rounded-md shadow-md flex-shrink-0"
                  />
                  <div>
                    <strong className="text-orange-600 text-lg">
                      ผู้ช่วยฆาตกร (Assistant)
                    </strong>
                    <p className="text-sm">
                      ในตอนกลางคืน จะได้รับรู้ "เบาะแสจริง" 1
                      ชิ้นที่เหยื่อทิ้งไว้ แต่ไม่รู้ว่าฆาตกรเป็นใคร
                      และฆาตกรก็ไม่รู้ว่าใครคือผู้ช่วย
                      เป้าหมายคือช่วยให้ฝ่ายฆาตกรชนะ <span className="text-amber-800 font-semibold">(หากถูกสังหารโดยฆาตกร จะย้ายมาอยู่ฝ่ายผู้บริสุทธิ์ทันทีโดยแสดงบทบาทเป็น "ผู้ช่วยฆาตกรกลับใจ" และอิงผลแพ้ชนะตามฝ่ายผู้บริสุทธิ์ แต่หากถูกโหวตออกจะยังอ้างอิงผลแพ้ชนะตามฝ่ายฆาตกรตามเดิม)</span>
                    </p>
                    <p className="text-xs text-red-700 italic mt-1">
                      (ต้องการผู้เล่น 5 คนขึ้นไป)
                    </p>
                  </div>
                </div>
                <div className="flex items-start gap-4">
                  <img
                    src="/images/role_cards/card_detective_v1.png"
                    alt="การ์ดนักสืบ"
                    className="w-20 h-auto rounded-md shadow-md flex-shrink-0"
                  />
                  <div>
                    <strong className="text-green-700 text-lg">
                      นักสืบ (Detective)
                    </strong>
                    <p className="text-sm">
                      ในตอนกลางคืน จะได้รับรู้ "เบาะแสจริง" 1
                      ชิ้นที่เหยื่อทิ้งไว้ ก่อนที่ฆาตกรจะใส่ของปลอมลงไป
                      ทำให้มีข้อมูลที่แม่นยำกว่าคนอื่น
                    </p>
                    <p className="text-xs text-red-700 italic mt-1">
                      (ต้องการผู้เล่น 5 คนขึ้นไป)
                    </p>
                  </div>
                </div>
                <div className="flex items-start gap-4">
                  <img
                    src="/images/role_cards/card_coroner_v1.png"
                    alt="การ์ดแพทย์นิติเวช"
                    className="w-20 h-auto rounded-md shadow-md flex-shrink-0"
                  />
                  <div>
                    <strong className="text-purple-900 text-lg">
                      แพทย์นิติเวช (Coroner)
                    </strong>
                    <p className="text-sm">
                      ในตอนกลางคืน จะเลือกชี้หลักฐาน 1 ชิ้นจาก 6 ชิ้นที่ไม่ได้อยู่ในคดี เพื่อแอบสอบถามเหยื่อว่า "เกี่ยวข้องกับหลักฐานจริงหรือไม่" โดยจะมีเพียงแพทย์นิติเวชคนเดียวเท่านั้นที่ได้รับคำตอบ (👍/👎) เพื่อใช้สืบหาคนร้าย
                    </p>
                    <p className="text-xs text-red-700 italic mt-1">
                      (ต้องการผู้เล่น 5 คนขึ้นไป)
                    </p>
                  </div>
                </div>
                <div className="flex items-start gap-4">
                  <img
                    src="/images/role_cards/card_agent_v1.png"
                    alt="การ์ดเอเจนต์"
                    className="w-20 h-auto rounded-md shadow-md flex-shrink-0"
                  />
                  <div>
                    <strong className="text-purple-700 text-lg">
                      เอเจนต์ (Agent)
                    </strong>
                    <p className="text-sm">
                      ในตอนกลางคืน จะเลือกสั่งปิดปากผู้เล่นคนอื่นได้ 1 คน
                      ทำให้ผู้เล่นคนนั้นมีสถานะถูกปิดปาก (🤐)
                      และห้ามพูดคุยวิเคราะห์หรือออกเสียงแสดงความเห็นในตอนกลางวันถัดไป
                    </p>
                    <p className="text-xs text-red-700 italic mt-1">
                      (ต้องการผู้เล่น 4 คนขึ้นไป)
                    </p>
                  </div>
                </div>
                <div className="flex items-start gap-4">
                  <img
                    src="/images/role_cards/card_innocent_v1.png"
                    alt="การ์ดผู้บริสุทธิ์"
                    className="w-20 h-auto rounded-md shadow-md flex-shrink-0"
                  />
                  <div>
                    <strong className="text-blue-800 text-lg">
                      ผู้บริสุทธิ์ (Innocent)
                    </strong>
                    <p className="text-sm">
                      ไม่มีความสามารถพิเศษ
                      เป้าหมายคือการวิเคราะห์หาตัวฆาตกรจากเบาะแสและการพูดคุยให้ได้
                    </p>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>

        <div className="mt-6 flex-shrink-0 flex items-center justify-between">
          <button
            onClick={() => setCurrentPage((p) => p - 1)}
            disabled={currentPage === 0}
            className="bg-[#a08d70] hover:bg-[#8d7c62] text-white font-bold py-2 px-6 rounded-lg transition-all disabled:opacity-30 disabled:cursor-not-allowed active:scale-95 active:shadow-inner disabled:scale-100 disabled:shadow-none"
          >
            {"< ก่อนหน้า"}
          </button>

          <div className="flex gap-2">
            {Array.from({ length: totalPages }).map((_, i) => (
              <div
                key={i}
                className={`w-3 h-3 rounded-full transition-colors ${
                  currentPage === i ? "bg-[#5a4a3a]" : "bg-[#c8bda9]"
                }`}
              ></div>
            ))}
          </div>

          {currentPage < totalPages - 1 ? (
            <button
              onClick={() => setCurrentPage((p) => p + 1)}
              className="bg-[#a08d70] hover:bg-[#8d7c62] text-white font-bold py-2 px-6 rounded-lg transition-all active:scale-95 active:shadow-inner"
            >
              {"ต่อไป >"}
            </button>
          ) : (
            <button
              onClick={handleClose}
              className="bg-[#556b2f] hover:bg-[#6B8E23] text-white font-bold py-2 px-6 rounded-lg transition-all active:scale-95 active:shadow-inner"
            >
              เข้าใจแล้ว
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
